<script setup lang="ts">
const offset = useHeaderHeight()
</script>

<template>
  <ContentDiv>
    <div class="flex flex-col md:flex-row gap-m lg:gap-l xl:gap-3xl max-w-screen-xl mx-auto py-xl">
      <div class="relative">
        <Card
          data-sticky-book-card
          class="sticky"
          type="book"
          size="large"
          presentation
        >
          <div class="flex justify-center">
            <Skeleton :class="cardVariants.image({ type: 'book', size: 'large', presentation: true })" class="rounded-lg" />
          </div>
        </Card>
      </div>
      <div class="flex-1 flex flex-col gap-xl pb-2xl">
        <div class="flex flex-col gap-l items-start">
          <hgroup class="flex flex-col gap-l w-full">
            <Skeleton class="h-15 w-1/2 rounded" />
            <Skeleton class="h-12 w-3/4 rounded" />
          </hgroup>

          <div class="flex flex-col xl:flex-row gap-m md:gap-xl w-full">
            <Skeleton class="h-8 w-64 rounded-full" />
            <Skeleton class="h-8 w-48 rounded-full" />
          </div>

          <Skeleton class="h-12 w-48 rounded-lg" />
        </div>
        <Skeleton class="h-6 w-48 rounded-lg" />
      </div>
    </div>
  </ContentDiv>
</template>

<style scoped lang="postcss">
[data-sticky-book-card] {
  top: calc(v-bind(offset) + theme('spacing.s'));
}

:deep(.commentary-description) {
  @apply flex items-start gap-l flex-col;

  p {
    @apply text-base font-normal;
  }

  h5 {
    @apply text-xl font-light;
  }
}
</style>
